import { render, staticRenderFns } from "./detailModal.vue?vue&type=template&id=5588b1cb&scoped=true&"
import script from "./detailModal.vue?vue&type=script&lang=ts&"
export * from "./detailModal.vue?vue&type=script&lang=ts&"
import style0 from "./detailModal.vue?vue&type=style&index=0&id=5588b1cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5588b1cb",
  null
  
)

export default component.exports